import { apiCallStatus } from 'helpers/constants';
import { actionTypes } from './constants';

const initialState = {
    filters: null,
    barCharts: {
        data: [],
        isLoading: apiCallStatus.LOADING,
    },
    anomalyData: {
        drivesWithCoolingAnomaly: null,
        drivesWithEnergyOutlier: null,
        rotatingEquipmentsWithAnomaly: null,
    },
    statistics: {
        assets: {
            data: [],
            pageNumber: 1,
            isLoading: apiCallStatus.LOADING,
            hasMoreResults: false,
        },
        assetGroups: {
            data: [],
            pageNumber: 1,
            isLoading: apiCallStatus.LOADING,
            hasMoreResults: false,
        },
        powertrains: {
            data: [],
            pageNumber: 1,
            isLoading: apiCallStatus.LOADING,
            hasMoreResults: false,
        }
    },
    aggregatedAnalytics: {
        assets: {
            data: [],
            isLoading: apiCallStatus.LOADING,
        },
        assetGroups: {
            data: [],
            isLoading: apiCallStatus.LOADING,
        },
        powertrains: {
            data: [],
            isLoading: apiCallStatus.LOADING,
        }
    },
    expandedAssetGroup: null,
    expandedPowertrain: null,
    initialLoadDone: false,
    isREC: false,
    isLSU: false,
    refreshCache: false,
    ciamSyncFlag: false
};

const addNewPageToStatisticsData = (items, action, type) => {
    const data = action?.loadingStatus !== apiCallStatus.LOADING &&
        items?.pageNumber === 1 ? [] : [...items?.data || []];

    return action.loadingStatus !== apiCallStatus.SUCCESS ? {
        ...items,
        isLoading: action.loadingStatus
    } : {
        ...items,
        isLoading: action.loadingStatus,
        count: action.data ? action.data?.count : 0,
        data: action.data && [...data, ...action.data[type] ? action.data[type] : []],
        pageNumber: action.data ? action.data?.hasMoreResults ? items?.pageNumber + 1 : items?.pageNumber : 1,
        initialLoadDone: true,
        hasMoreResults: action.data?.hasMoreResults
    };
};

const handleStatisticsData = (state, type, action) => {
    return {
        ...state,
        statistics: {
            ...state.statistics,
            [type]: {
                ...addNewPageToStatisticsData(state?.statistics[type], action, type)
            },
        }
    };
};

const handleAnalyticsAggregatedData = (state, type, action) => {
    return {
        ...state,
        aggregatedAnalytics: {
            ...state.aggregatedAnalytics,
            [type]: {
                data: action?.data || [],
                isLoading: action?.loadingStatus,
            }
        },
        initialLoadDone: true
    };
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_FLEET_OVERVIEW_INITIAL_LOAD:
            return {
                ...state,
                filters: { ...initialState.filters },
                aggregatedAnalytics: { ...initialState.aggregatedAnalytics },
                statistics: { ...initialState.statistics },
                barCharts: { ...initialState.barCharts },
                initialLoadDone: false
            };
        case actionTypes.GET_BAR_CHARTS:
            return {
                ...state,
                barCharts: {
                    data: action?.data?.aggregatedConditions || [],
                    isLoading: action?.loadingStatus,
                },
                anomalyData: {
                    drivesWithCoolingAnomaly: action?.data?.drivesWithCoolingAnomaly || null,
                    drivesWithEnergyOutlier: action?.data?.drivesWithEnergyOutlier || null,
                    rotatingEquipmentsWithAnomaly: action?.data?.rotatingEquipmentsWithAnomaly || null,
                }
            };
        /* STATISTICS DATA */
        case actionTypes.GET_STATISTICS_ASSETS:
            return handleStatisticsData(state, 'assets', action);
        case actionTypes.GET_STATISTICS_ASSETSGROUP:
            return handleStatisticsData(state, 'assetGroups', action);
        case actionTypes.GET_STATISTICS_POWERTRAIN:
            return handleStatisticsData(state, 'powertrains', action);

        /* ANALYTICS AGGREGATED DATA */
        case actionTypes.GET_ANALYTICS_AGGREGATED_ASSET:
            return handleAnalyticsAggregatedData(state, 'assets', action);
        case actionTypes.GET_ANALYTICS_AGGREGATED_ASSETGROUP:
            return handleAnalyticsAggregatedData(state, 'assetGroups', action);
        case actionTypes.GET_ANALYTICS_AGGREGATED_POWERTRAIN:
            return handleAnalyticsAggregatedData(state, 'powertrains', action);

        case actionTypes.SET_EXPANDED_ASSET_GROUP:
            return {
                ...state,
                expandedAssetGroup: action?.data
            };
        case actionTypes.SET_EXPANDED_POWERTRAIN:
            return {
                ...state,
                expandedPowertrain: action?.data
            };
        case actionTypes.CLEAR_FLEET_OVERVIEW_DATA:
            return { ...initialState };
        case actionTypes.SET_FLEET_USER_TYPE:
            return {
                ...state,
                isREC: action?.isREC,
                isLSU: action?.isLSU
            };
        case actionTypes.UPDATE_REFRESH_CACHE_FLAG:
            return {
                ...state,
                refreshCache: action?.refreshCache,
                ciamSyncFlag: action?.ciamSyncFlag || false
            };

        default:
            return state;
    }
};

export default reducer;
